import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router"
import { getId, usePermissions } from "../../user/User"
import { toast } from "react-toastify"
import { useEffect } from "react"
import { useTag } from "../../tag/Tag"
import TagDetailView from './TagDetailView'

const TagEdit = () => {
    const navigate = useNavigate()

    let { id } = useParams()
    let {
        name, setName,
    } = useTag(id)

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.tag !== undefined && !permissions.tag) {
            toast.error("You don't have permission to edit tags!")
            navigate("/")
        }
    }, [permissions])

    return <TagDetailView id={id}
        name={name} setName={setName}
    />
}

export default TagEdit